import TimeseriesPage from './TimeseriesPage';

export default TimeseriesPage;
